export const API_URL ='https://servidor.angonet.ao/api';


//export const API_URL = 'http://127.0.0.1:8000/api';